export default {_name:'Text.StatusChip',module:'Field',view:'Element/Text/StatusChip',webOptions:{md:2},mobileOptions:{ms:2}}